import { observer } from 'mobx-react-lite';

import _ from 'lodash';
import { makeAutoObservable, runInAction } from 'mobx';
import { useEffect } from 'react';
import { StockIndexResponse } from '../../../server/response/responseScheme';
import { apiClient } from '../../utils/apiClient';
import { useMobxInstance } from '../../utils/mobxUtil';
import ChangeBarGraph, { ChangeBarGraphItem } from './ChangeBarGraph';
import TargetReturnButton from './TargetReturnButton';

class ViewStore {
    indexPerformance: StockIndexResponse[] = [];

    graphItems: ChangeBarGraphItem<{ indexTicker: string }>[] = [];
    briefingIndex: StockIndexResponse | null = null;
    briefDate: string | null = null;
    targetReturn: 'daily' | 'mtd' | 'ytd' = 'daily';

    constructor() {
        makeAutoObservable(this);
    }

    async fetch() {
        const response = await apiClient.stockIndex.public.getGlobalPerformance.$query();

        runInAction(() => {
            this.indexPerformance = response;

            const lastDate = _.last(this.indexPerformance)?.price?.date;
            if (lastDate) {
                this.briefDate = lastDate;
            }

            this.makeGraphItems();
        });
    }

    private makeGraphItems() {
        // 정렬된 데이터 캐시
        this.graphItems = _.map(this.indexPerformance, (item) => {
            let targetReturn = 0;

            if (this.targetReturn === 'daily') {
                targetReturn = Number(item.price?.dailyReturn) || 0;
            } else if (this.targetReturn === 'mtd') {
                targetReturn = Number(item.price?.mtdReturn) || 0;
            } else if (this.targetReturn === 'ytd') {
                targetReturn = Number(item.price?.ytdReturn) || 0;
            }

            return {
                name: item.label!,
                subName: item.nameKo!,
                changePercent: targetReturn,
                isBenchmark: item.ticker === '_SP500',
                data: {
                    indexTicker: item.ticker,
                },
            };
        });
    }

    get highlightPercent() {
        return this.targetReturn === 'daily' ? 1 : this.targetReturn === 'mtd' ? 3 : 10;
    }

    changeTargetReturn(target: 'daily' | 'mtd' | 'ytd') {
        this.targetReturn = target;
        this.makeGraphItems();
    }
}

const GlobalBriefCard = observer(({ className }: { className?: string }) => {
    const viewStore = useMobxInstance(ViewStore);

    useEffect(() => {
        viewStore.fetch();
    }, [viewStore]);

    return (
        <div>
            <ChangeBarGraph<{ indexTicker: string }>
                items={viewStore.graphItems}
                highligthPercent={viewStore.highlightPercent}
                className="-mx-5 mt-4 grow justify-between gap-2"
            />
            {viewStore.briefDate && (
                <TargetReturnButton
                    className="mt-8"
                    targetDate={viewStore.briefDate}
                    targetReturn={viewStore.targetReturn}
                    onChangeTargetReturn={(target) => viewStore.changeTargetReturn(target)}
                />
            )}
        </div>
    );
});

export default GlobalBriefCard;
